var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 3,
    viewBox: "0 0 22 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48534 0.0415039C0.665009 0.0415039 0 0.694421 0 1.49984C0 2.30525 0.66501 2.95817 1.48534 2.95817H9.47222H12.5278H20.5147C21.335 2.95817 22 2.30525 22 1.49984C22 0.694421 21.335 0.0415039 20.5147 0.0415039H12.5278H9.47222H1.48534Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.2062e4df60116243f42c8baa8f233a2f.svg";
export { ForwardRef as ReactComponent };